import styled from "styled-components/macro"

export const Container = styled.ul`
  width: 100%;
  min-height: 20rem;
  height: auto !important;
`

